import React, {Fragment }  from "react";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const DateInput = ({ name, label, error,  value, onChange }) => {
    const inputLabelId = name + "-label";
    return (
              
        <div className="col-lg-3 col-md-6">
            <div className="MuiFormControl-root MuiTextField-root calendar-parent">
                <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled Mui-required Mui-required" data-shrink="true" >
                    {label}</label>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Fragment>
                        <DatePicker
                            label={label}
                            value={value}
                            onChange={(date)=>onChange(name,date)}
                            minDate={new Date("01/01/2012")}
                            slotProps={{ textField: {} }}
                        />
                    </Fragment>
                </LocalizationProvider>

            </div>
            {error && <small className="text-danger">{error}</small>}
        </div>
    );
};

export default DateInput;